@if (enableType) {
  <div class="lib-alert" (click)="close()"
       [class.lib-alert--error]="enableType.type === 'error'"
       [class.lib-alert--warning]="enableType.type === 'warning'"
       [class.lib-alert--info]="enableType.type === 'info'"
       [class.lib-alert--success]="enableType.type === 'success'">
    <div class="lib-alert__content">{{enableType.text}}</div>
  </div>
}
